module.exports = __webpack_public_path__ + "static/media/event-services-img1.f6faa5de.jpg";